module.exports = __webpack_public_path__ + "img/popup-game-sucai.5e3464cc.png";